import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const MD_BREAKPOINT = 744;

export default function initDetailCarousel() {
  const detailSwiperWrappers = document.querySelectorAll(".detail-banner .thumbnail");

  if (!detailSwiperWrappers.length) return;

  detailSwiperWrappers.forEach((wrapper) => {
    const swiperContainer = wrapper.querySelector(".detail-thumbnail-swiper");
    const prevButton = wrapper.querySelector(".detail-thumbnail-swiper .swiper-button-prev");
    const nextButton = wrapper.querySelector(".detail-thumbnail-swiper .swiper-button-next");
    const toggler = wrapper.querySelector(".detail-thumbnail-toggler");
    const togglerCount = toggler?.querySelector("span");
    // Support modal inside wrapper OR external modal via data-modal-target
    const modalTarget = toggler?.dataset.modalTarget;
    const modal = modalTarget
      ? document.querySelector(modalTarget)
      : wrapper.querySelector(".detail-thumbnail-modal");

    if (!swiperContainer) return;

    // Update toggler count (remaining slides)
    const slides = swiperContainer.querySelectorAll(".swiper-slide");
    const totalSlides = slides.length;
    const remainingSlides = totalSlides - 1;

    if (togglerCount && remainingSlides > 0) {
      togglerCount.textContent = `${remainingSlides}+`;
    }

    let desktopSwiper = null;
    let modalSwiper = null;

    function initDesktopSwiper() {
      if (desktopSwiper) return;

      desktopSwiper = new Swiper(swiperContainer, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
        },
      });
    }

    function destroyDesktopSwiper() {
      if (desktopSwiper) {
        desktopSwiper.destroy(true, true);
        desktopSwiper = null;
      }
    }

    function handleResize() {
      if (window.innerWidth >= MD_BREAKPOINT) {
        initDesktopSwiper();
      } else {
        destroyDesktopSwiper();
      }
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    if (toggler && modal) {
      const modalSwiperContainer = modal.querySelector(".detail-thumbnail-modal-swiper");
      const modalPrevButton = modal.querySelector(".carousel-button-prev");
      const modalNextButton = modal.querySelector(".carousel-button-next");
      const progressBar = modal.querySelector(".carousel-progress-bar");
      const modalControls = modal.querySelector(".carousel-controls");
      const closeButton = modal.querySelector(".modal-close");

      function updateProgressBar(swiper) {
        if (!swiper || !progressBar) return;

        const total = swiper.slides.length;
        const currentIndex = swiper.realIndex + 1;
        const progress = (currentIndex / total) * 100;
        progressBar.style.width = `${progress}%`;
      }

      function updateControlsVisibility(swiper) {
        if (!modalControls) return;
        if (swiper.slides.length <= 1) {
          modalControls.style.display = "none";
        } else {
          modalControls.style.display = "";
        }
      }

      function openModal() {
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        document.body.classList.add("modal-open");
        document.body.style.overflow = "hidden";

        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;
        }

        modal.style.display = "flex";
        setTimeout(() => {
          modal.classList.add("show");
        }, 10);

        if (!modalSwiper && modalSwiperContainer) {
          modalSwiper = new Swiper(modalSwiperContainer, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            navigation: {
              prevEl: modalPrevButton,
              nextEl: modalNextButton,
            },
            on: {
              init: function () {
                updateProgressBar(this);
                updateControlsVisibility(this);
              },
              slideChange: updateProgressBar,
            },
          });
        }
      }

      function closeModal() {
        modal.classList.remove("show");

        setTimeout(() => {
          modal.style.display = "none";
          document.body.classList.remove("modal-open");
          document.body.style.overflow = "";
          document.body.style.paddingRight = "";
        }, 150);
      }

      function handleKeydown(e) {
        if (e.key === "Escape" && modal.classList.contains("show")) {
          closeModal();
        }
      }

      toggler.addEventListener("click", openModal);

      if (closeButton) {
        closeButton.addEventListener("click", closeModal);
      }

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });

      document.addEventListener("keydown", handleKeydown);
    }
  });
}
